import { REPORT_JOB_TYPES } from '../../entities';
import type { SNSMessageAttributes } from '../sns/message-attribute-types';

const MESSAGE_ATTRIBUTE_NAME = 'reportType';
const MESSAGE_ATTRIBUTE_DATA_TYPE = 'String';

export const TRIGGER_REPORT_JOB_MESSAGE_ATTRIBUTES = Object.freeze({
  commitmentUsage: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.CommitmentUsage),
  unchargedUsage: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.UnchargedUsage),
  productsUsage: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.ProductsUsage),
  customerRevenue: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.CustomerRevenue),
  contracts: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.Contracts),
  monthlyClosure: getMessageAttribute(MESSAGE_ATTRIBUTE_NAME, REPORT_JOB_TYPES.MonthlyClosure),
}) satisfies Record<string, SNSMessageAttributes>;

function getMessageAttribute(name: string, value: string): SNSMessageAttributes {
  return { [name]: { DataType: MESSAGE_ATTRIBUTE_DATA_TYPE, StringValue: value } } as const;
}